import React from "react";
import { router } from "@inertiajs/react";

const MENTION_REGEX = /@([a-z0-9_]{3,30})/gi;
const HASHTAG_REGEX = /#([a-zA-Z0-9_]{1,50})\b/g;

function parseInlineElements(text, key) {
  const parts = [];
  let lastIndex = 0;
  const combined = new RegExp(`${MENTION_REGEX.source}|${HASHTAG_REGEX.source}`, "gi");
  let match;

  while ((match = combined.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (match[0].startsWith("@")) {
      const username = match[1] || match[0].slice(1);
      const mentionHref = `/communities/profiles/${username.toLowerCase()}`;
      parts.push(
        <a
          key={`${key}-m-${match.index}`}
          href={mentionHref}
          style={{ color: "var(--primary, #ff9900)", fontWeight: 600, textDecoration: "none" }}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); router.visit(mentionHref); }}
        >
          @{username}
        </a>
      );
    } else if (match[0].startsWith("#")) {
      const tag = match[2] || match[0].slice(1);
      const hashHref = `/communities/explore?topic=${tag.toLowerCase()}`;
      parts.push(
        <a
          key={`${key}-h-${match.index}`}
          href={hashHref}
          style={{ color: "var(--primary, #ff9900)", fontWeight: 600, textDecoration: "none" }}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); router.visit(hashHref); }}
        >
          #{tag}
        </a>
      );
    }
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
}

export function renderContent(content) {
  if (!content) return null;
  const lines = content.split("\n");
  return lines.map((line, i) => {
    if (/^- \[[ x]\] /.test(line)) {
      const textPart = line.replace(/^- \[[ x]\] /, "");
      return (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <input
            type="checkbox"
            defaultChecked={line.startsWith("- [x]")}
            readOnly
            style={{ cursor: "default" }}
          />
          <span>{parseInlineElements(textPart, i)}</span>
        </div>
      );
    }
    return (
      <React.Fragment key={i}>
        {parseInlineElements(line, i)}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
}
